import { Component } from '@theme/component';

/**
 * Wires the top navigation arrows of the inline article products slider
 * to the underlying `slideshow-component`. Mirrors the behaviour used by
 * the Recently viewed products section.
 */
class ArticleProductsSlider extends Component {
  connectedCallback() {
    super.connectedCallback();
    // Defer until children (slideshow) are parsed.
    requestAnimationFrame(() => this.#wireTopArrows());
  }

  #wireTopArrows() {
    const topArrows = this.querySelector('.article-inline-slider__top-arrows');
    if (!topArrows) return;

    /** @type {any} */
    const slideshow = this.querySelector('slideshow-component');
    if (!slideshow) return;

    /** @type {HTMLButtonElement | null} */
    const prevBtn = topArrows.querySelector('.article-inline-slider__arrow--prev');
    /** @type {HTMLButtonElement | null} */
    const nextBtn = topArrows.querySelector('.article-inline-slider__arrow--next');

    if (prevBtn) prevBtn.addEventListener('click', () => slideshow.previous());
    if (nextBtn) nextBtn.addEventListener('click', () => slideshow.next());

    const updateDisabled = () => {
      const slides = slideshow.slides;
      if (prevBtn) prevBtn.disabled = Boolean(!slideshow.infinite && slideshow.current === 0);
      if (nextBtn) nextBtn.disabled = Boolean(!slideshow.infinite && slides && slideshow.nextIndex >= slides.length);
    };

    slideshow.addEventListener('slideshow:select', updateDisabled);
    requestAnimationFrame(() => updateDisabled());
  }
}

if (!customElements.get('article-products-slider')) {
  customElements.define('article-products-slider', ArticleProductsSlider);
}
